import {
  useCorporateTopIssuersContext,
} from '@/creditflowresearch/application/TopCompanies/corporateTopCompanies/CorporateTopIssuersContext';
import { PARENT_NAME } from '@/creditflowresearch/ui/components/TopCompanies/constants';
import CorporateTable
  from '@/creditflowresearch/ui/components/TopCompanies/TopCompaniesTables/CorporateTables/CorporateTable';

const CorporateTopIssuers = () => {
  const { data, loading, page, paginate } = useCorporateTopIssuersContext();

  return (
    <CorporateTable
      data={ data }
      loading={ loading }
      page={ page }
      paginate={ paginate }
      companyRole={ PARENT_NAME }
      emptyMessageText="No issuers during the selected period."
    />
  );
};

export default CorporateTopIssuers;
